import { NavLink, Outlet } from "react-router-dom";
import { IconMark } from "./ui/icons";
import ChatWidget from "./chat/ChatWidget";

// Public by design — this is a "chat with us" contact link meant to be
// visible on the live site, not a secret. Set in apps/web/.env.production.
const TELEGRAM_USERNAME = import.meta.env.VITE_TELEGRAM_USERNAME as string | undefined;

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `relative px-3 py-2 text-sm font-medium transition-colors ${
    isActive
      ? "text-paper after:absolute after:left-3 after:right-3 after:-bottom-[1px] after:h-0.5 after:rounded-full after:bg-ledger-500"
      : "text-muted hover:text-paper"
  }`;

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="sticky top-0 z-30 border-b border-ink-700 bg-ink-950/85 backdrop-blur-sm">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <NavLink to="/" className="flex items-center gap-2.5">
            <span className="flex items-center justify-center w-8 h-8 rounded-md bg-ledger-500/15 text-ledger-400">
              <IconMark className="w-[18px] h-[18px]" />
            </span>
            <span className="font-display text-lg tracking-tight">WalletRecover</span>
          </NavLink>
          <nav className="flex items-center gap-1">
            <NavLink to="/recover" className={navLinkClass}>
              Recover
            </NavLink>
            <NavLink to="/trace" className={navLinkClass}>
              Trace
            </NavLink>
            <NavLink to="/demo" className={navLinkClass}>
              Demo
            </NavLink>
            <NavLink to="/blog" className={navLinkClass}>
              Blog
            </NavLink>
            <NavLink to="/news" className={navLinkClass}>
              News
            </NavLink>
          </nav>
        </div>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t border-ink-700 py-6 text-center text-sm text-muted">
        <p>Recovery runs entirely on your device. Tracing uses only public blockchain data.</p>
        {TELEGRAM_USERNAME && (
          <a
            href={`https://t.me/${TELEGRAM_USERNAME}`}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 inline-block text-ledger-400 hover:underline"
          >
            Chat with us on Telegram
          </a>
        )}
      </footer>
      <ChatWidget />
    </div>
  );
}
